// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700&display=swap.css);"]);
// Module
exports.push([module.id, ".dropdown-question-wrapper[data-v-a408adda]{display:flex;flex-direction:column;align-items:center}.dropdown-select[data-v-a408adda]{width:calc(100% - 40px);max-width:600px}.button-spacer[data-v-a408adda]{margin-top:12px;z-index:2}.v-spacing[data-v-a408adda]{margin-top:20px;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
